import { render } from "./CustomizeUser.vue?vue&type=template&id=7dfe2533&scoped=true"
import script from "./CustomizeUser.vue?vue&type=script&lang=js"
export * from "./CustomizeUser.vue?vue&type=script&lang=js"

import "./CustomizeUser.vue?vue&type=style&index=0&id=7dfe2533&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dfe2533"]])

export default __exports__